'use client';
import React from 'react';
import { Swiper, SwiperProps, SwiperRef } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
// import required modules
import {
  Keyboard,
  Scrollbar,
  Navigation,
  Pagination,
  A11y,
  Autoplay
} from 'swiper/modules';
import PropTypes from 'prop-types';

/**
 * This Carousel component provides a reusable, customizable slider/carousel functionality
 * with built-in keyboard support, scrollbar, navigation, pagination, and accessibility features.
 * It properly forwards refs to allow external control of the Swiper instance.
 */
export const Carousel = React.forwardRef<
  SwiperRef,
  React.PropsWithChildren<SwiperProps>
>(({ children, ...rest }, ref): JSX.Element => {
  return (
    <Swiper
      ref={ref}
      {...rest}
      modules={[Keyboard, Scrollbar, Navigation, Pagination, A11y, Autoplay]}
    >
      {children}
    </Swiper>
  );
});

// Set display name for debugging
Carousel.displayName = 'Carousel';

// prop type validation for the children
Carousel.propTypes = { children: PropTypes.node.isRequired };

export default Carousel;
